import React, { useEffect, Fragment, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import withDashboard from "../../HOC/withDashboard";
import Pagination from "../../components/NewPagination";
import PreviewIcon from "@mui/icons-material/Preview";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  getDWRequests,
  deleteCustomReferralCode,
  setAdminReferral,
} from "../../redux/actions/customReferralAction";
import { fetchWithdrawRequests } from "../../services/CustomReferralCodeService";
import { setUser, setUserDetailProfile } from "../../redux/actions/userAction";
import {
  ButtonBase,
  Button,
  InputAdornment,
  TextField,
  Card,
  IconButton,
  CircularProgress,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import Loader from "../../components/Loader";
import Swal from "sweetalert2";
import "../Users/index.css"; // Reuse Users styling for consistency
import PeopleSharpIcon from "@mui/icons-material/PeopleSharp";

const DWRequests = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = React.useState(false);
  const [customReferralCode, setCustomReferralCode] = React.useState([]);
  const User = useSelector(({ User }) => User);
  const {
    filteredReferrals,
    paginatedReferrals,
    currentReferralPage,
    totalReferralPages,
    referralPerPage,
    referralSearch,
    testConfig,
    prodConfig,
    enviroment,
  } = User;
  const [totalRecord, setTotalRecord] = useState(0);
  const [dataRecord, setDataRecord] = React.useState([]);
  const [dataRecordFilter, setDataRecordFilter] = useState({
    search: "",
    page: 0,
    limit: 10,
    type: "",
    status: "",
  });

  useEffect(() => {
    getDataRecord();
  }, [dataRecordFilter]);

  const onChangeFilter = (name, value) => {
    setDataRecordFilter({ ...dataRecordFilter, [name]: value });
  };

  const getDataRecord = () => {
    setIsLoading(true);
    dispatch(getDWRequests(dataRecordFilter))
      .then((res) => {
        console.log(res?.data?.data);
        
        setTotalRecord(res?.data?.total);
        setDataRecord(res?.data?.data);
        setIsLoading(false);
      })
      .catch(({ message, errorData, statusCode }) => {
        console.error("Error fetching gift card categories:", message);
        setIsLoading(false);
      });
  };

  const handleDelete = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(deleteCustomReferralCode({ id }));
        getDataRecord();
      }
    });
  };

  return (
    <Fragment>
      <div className="table-layout-container">
        <div className="order-accordian-row">
          <div className="order-accordian-container">
            <ButtonBase>
              <div
                className={`order-accordian-item left ${
                  dataRecordFilter?.type === "" && "selected"
                }`}
                onClick={() => onChangeFilter("type", "")}
              >
                All
              </div>
            </ButtonBase>
            <ButtonBase>
              <div
                className={`order-accordian-item ${
                  dataRecordFilter?.type === "Deposit" && "selected"
                }`}
                onClick={() => onChangeFilter("type", "Deposit")}
              >
                Deposit
              </div>
            </ButtonBase>
            <ButtonBase>
              <div
                className={`order-accordian-item right ${
                  dataRecordFilter?.type === "Withdraw" && "selected"
                }`}
                onClick={() => onChangeFilter("type", "Withdraw")}
              >
                Withdraw
              </div>
            </ButtonBase>
          </div>
          <div className="order-status-accordian-container">
            <div className="order-accordian-container">
              <ButtonBase>
                <div
                  className={`order-accordian-item left ${
                    dataRecordFilter?.status === "" && "selected"
                  }`}
                  onClick={() => onChangeFilter("status", "")}
                >
                  All
                </div>
              </ButtonBase>
              <ButtonBase>
                <div
                  className={`order-accordian-item  ${
                    dataRecordFilter?.status === "pending" && "selected"
                  }`}
                  onClick={() => onChangeFilter("status", "pending")}
                >
                  Pending
                </div>
              </ButtonBase>
              <ButtonBase>
                <div
                  className={`order-accordian-item  ${
                    dataRecordFilter?.status === "completed" && "selected"
                  }`}
                  onClick={() => onChangeFilter("status", "completed")}
                >
                  Completed
                </div>
              </ButtonBase>
              <ButtonBase>
                <div
                  className={`order-accordian-item right ${
                    dataRecordFilter?.status === "rejected" && "selected"
                  }`}
                  onClick={() => onChangeFilter("status", "rejected")}
                >
                  Rejected
                </div>
              </ButtonBase>
            </div>
          </div>
        </div>
        <Card className="gift-cards-category-card">
          <div className="table-title">
            <span>List of D & W Request</span>
          </div>
          <div className="gift-cards-table-container">
            {isLoading ? (
              <div className="flex justify-center items-center p-4">
                <CircularProgress />
              </div>
            ) : (
              <table>
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Account No</th>
                    <th>Bank Name </th>
                    <th>Amount </th>
                    <th>Type</th>
                    <th>Status</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {dataRecord &&
                    dataRecord.length > 0 &&
                    dataRecord.map((item) => (
                      <tr key={item?._id}>
                        <td>{item._id}</td>
                        <td>{item.accountNumber}</td>
                        <td>{item.bankName}</td>
                        <td>{item.amount}</td>
                        <td>{item.type}</td>
                        <td>{item.status}</td>
                        <td>
                          <div className="action-row">
                            <Button
                              className="action-btn edit"
                              variant="contained"
                              onClick={() =>
                                navigate(`/dw-requests/edit/${item._id}`)
                              }
                            >
                              <PreviewIcon />
                              <span> View</span>
                            </Button>
                          </div>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            )}
          </div>
          <div className="gift-cards-pagination-container">
            <Pagination
              items={totalRecord}
              initialPage={dataRecordFilter?.page}
              onChangePage={onChangeFilter}
              per_page={dataRecordFilter?.limit}
            />
          </div>
        </Card>
      </div>
    </Fragment>
  );
};
export default withDashboard(DWRequests);
